import gjeldsreduksjonFastland2023 from './2023/gjeldsreduksjonFastland.json';
import gjeldsreduksjonSvalbard2023 from './2023/gjeldsreduksjonSvalbard.json';

export const gjeldsreduksjonFastland = {
  2023: gjeldsreduksjonFastland2023,
};
export const gjeldsreduksjonSvalbard = {
  2023: gjeldsreduksjonSvalbard2023,
};
